import React from "react";
import styled from "styled-components";
import { Asset } from "src/types";
import { colors } from "src/styles";

export interface AssetCardProps {
  asset: Asset;
  onClick?: () => void;
}

export const AssetCard = ({ asset, onClick }: AssetCardProps) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.getFullYear().toString();
    } catch {
      return dateString;
    }
  };

  const statusValue = asset.status_description || asset.status || "N/A";

  return (
    <Card
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (!onClick) {
          return;
        }
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <Row>
        <Label>Station ID:</Label>
        <Value>{asset.siteid || asset.stationId || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Site Name:</Label>
        <Value>{asset.stationName || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Asset Code:</Label>
        <Value>{asset.assetnum || asset.assetCode || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Description:</Label>
        <Value>{asset.description || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Category:</Label>
        <Value>{asset.assettype_description || asset.assettype || asset.category || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Sub Category:</Label>
        <Value>{asset.subCategory || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Location of Asset:</Label>
        <Value>{asset.location || asset.roomLocation || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Install Year:</Label>
        <Value>{formatDate(asset.installdate) || asset.installYear || "N/A"}</Value>
      </Row>
      <Row>
        <Label>Status:</Label>
        <StatusBadge status={asset.status || "UNKNOWN"}>{statusValue}</StatusBadge>
      </Row>
    </Card>
  );
};

const Card = styled.div`
  background: ${colors.white.default};
  border: 1px solid ${colors.grey.light11};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.grey.light3};

  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${colors.grey.dark6};
`;

const Value = styled.span`
  font-size: 14px;
  color: ${colors.grey.default};
  text-align: right;
`;

const StatusBadge = styled.span<{ status: string }>`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ status }) => {
    switch (status.toLowerCase()) {
      case "active":
        return colors.kleenway.greenLight;
      case "inactive":
        return colors.grey.light10;
      case "maintenance":
        return "#fff4e6";
      default:
        return colors.grey.light3;
    }
  }};
  color: ${({ status }) => {
    switch (status.toLowerCase()) {
      case "active":
        return colors.kleenway.green;
      case "inactive":
        return colors.grey.dark6;
      case "maintenance":
        return "#d46b08";
      default:
        return colors.grey.default;
    }
  }};
`;
